import initialState from 'reducers/initialState';
import { FILL_ADVISOR_DATA } from 'store/constants';
import { get } from 'lodash';
import * as types from 'actions/actionTypes';
import fallbackFillAdvisorData from './fallbackFillAdvisorData';

const reducer = (state = initialState[FILL_ADVISOR_DATA], action) => {
  switch (action.type) {
    case types.GET_FILL_ADVISOR_DATA.SUCCESS:
      return {
        weight: get(action, 'payload.weight'),
        coefficient: get(action, 'payload.coefficient'),
        threshold: get(action, 'payload.threshold'),
        infoText: get(action, 'payload.infoText'),
        summaryText: get(action, 'payload.summaryText'),
        keyValues: get(action, 'payload.keyValues'),
        gaugeText: get(action, 'payload.gaugeText')
      };
    case types.GET_FILL_ADVISOR_DATA.FAILURE:
      return {
        weight: get(fallbackFillAdvisorData, 'weight'),
        coefficient: get(fallbackFillAdvisorData, 'coefficient'),
        threshold: get(fallbackFillAdvisorData, 'threshold'),
        infoText: get(fallbackFillAdvisorData, 'infoText'),
        summaryText: get(fallbackFillAdvisorData, 'summaryText'),
        keyValues: get(fallbackFillAdvisorData, 'keyValues'),
        gaugeText: get(fallbackFillAdvisorData, 'gaugeText')
      };
    default:
      return state;
  }
};

export default reducer;
